import { WORLD_WIDTH } from './config'

export interface Shuttle {
  x: number
  y: number
  vx: number
  vy: number
}

export interface ShuttlePhysics {
  gravity: number
  drag: number
  radius: number
  wallBounce: number
  /** Боковое ускорение от ветра, ед./с². */
  wind: number
}

/**
 * Один шаг полёта: гравитация, ветер и квадратичное сопротивление, отскок от
 * боковых стенок. Верх поля открыт — волан может вылететь за экран и вернуться сам.
 */
export function stepShuttle(s: Shuttle, dt: number, p: ShuttlePhysics): Shuttle {
  const speed = Math.hypot(s.vx, s.vy)
  // Полунеявный Эйлер: сначала скорость, потом позиция по новой скорости —
  // стабильнее явного при сильном сопротивлении.
  let vx = s.vx + (p.wind - p.drag * speed * s.vx) * dt
  const vy = s.vy + (p.gravity - p.drag * speed * s.vy) * dt
  let x = s.x + vx * dt
  const y = s.y + vy * dt

  if (x < p.radius) {
    x = p.radius
    vx = Math.abs(vx) * p.wallBounce
  } else if (x > WORLD_WIDTH - p.radius) {
    x = WORLD_WIDTH - p.radius
    vx = -Math.abs(vx) * p.wallBounce
  }

  return { x, y, vx, vy }
}
